var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-error-layer"},[_c('h4',[_vm._v("კავშირის პრობლემა")]),_c('loading',{attrs:{"color":"#5B4343"}}),_c('h6',[_vm._v("დაკავშირების მცდელობა ("+_vm._s(_vm.currentConnectionAttempt)+")")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }